module.exports = __webpack_public_path__ + "images/d439655d2832deb08ed53e346fc1c6d3-PUERTOMORELOS-WHITE.png";